module.exports = __webpack_public_path__ + "img/slideVerify_02.f8a5b482.png";